<template>
  <div>
    <div class="white black--text">
      <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>
      <div v-if="pickedItem">{{pickedItem.title}}</div>
      <v-select
          :items="listingNames"
          label="Select listing"
          dense
          outlined
          v-model="selectedListingName"
      ></v-select>
      <v-menu offset-y allow-overflow>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              label="Add line item"
              v-model="searchItem"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>

        <v-list v-if="filteredList.length === 0" two-line>
          <v-list-item >
            <v-list-item-title>{{searchItem}}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list v-if="filteredList.length !== 0">
          <v-list-item
              v-for="(item, index) in filteredList"
              :key="index"
              @click="itemPicked(item)"
          >
            <v-list-item-title>{{ item.title}}</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
    </div>
  </div>
</template>
<script>
import {collection, getDocs, doc, getDoc, onSnapshot} from "firebase/firestore";
import {v1 as uuidv1} from "uuid";
export default {
  props: ['listingId'],
  data () {
    return {
      searchItem: '',
      pickedItem: undefined,
      clientItem: false,
      filteredItems: [],
      items: [],
      listingNames: [],
      selectedListingName: null,
      selectedListing: null,
      listings: []
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    filteredList () {
      if(this.items.length !== 0) {
        return this.items.filter((item) => {
          return item.title.toLowerCase().match(this.searchItem.toLowerCase())
        })
      } else return []
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    selectedListingName (listingName) {
      // console.log(listingName)
        let listing = this.listings.find(listing => {
          return listing.listingName === listingName
        })
        this.selectedListing = listing
      if(listing) {
        this.loadSelectedListingItems(listing.id)
      }
    }
  },
  created () {
    //console.log(this.listingId)
    let db = this.$store.state.db
    if (this.listingId) {
      this.loadSelectedListingItems(this.listingId)
    } else {
      let listingRef = collection(db, 'users', this.user.uid + '/listings')
      onSnapshot(listingRef, res => {
        if (res && res.empty !== true) {
          let listings = []
          let sortedListings = []
          res.forEach(doc => {
            let data = doc.data()
            //console.log(data)
            listings.push(data)
            sortedListings.push(data.listingName)
          })
          this.listings = listings
          this.listingNames = sortedListings
          let firstListingId = listings[0].id
          this.loadSelectedListingItems(firstListingId)
          this.selectedListingName = listings[0].listingName
          this.selectedListing = listings[0]
        }
      })
    }
    //let itemRef = collection(db, 'users', this.user.uid + '/items')
  },
  methods: {
    loadSelectedListingItems (listingId) {
      let db = this.$store.state.db
      let itemsRef = collection(db, 'users', this.user.uid + '/listings/' + listingId +'/items')
      return getDocs(itemsRef)
          .then(res => {
            if (res && res.empty !== true) {
              let items = []
              let sortedItems = []
              res.forEach(doc => {
                let data = doc.data()
                //console.log(data)
                items.push(data)
              })
              sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
              this.items = sortedItems
              //console.log(this.items)
            }
          })
          .then(() => {
            let listingRef = doc(db, 'users', this.user.uid + '/listings/' + listingId)
            return getDoc(listingRef)
          })
          .then (res => {
            if(res.exists()) {
              let data = res.data()
              this.selectedListingName = data.listingName
              this.selectedListing = data
            }
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
            this.$store.dispatch("setLoading", false)
            console.log(err)
          })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    itemPicked(value) {
      this.pickedItem = value
      let newItem = {
        ...value}
      this.pickedItem.listing = this.selectedListing
      this.searchItem = ''
      // console.log(value)
      newItem.id = uuidv1()
      newItem.price = 0
      newItem.cost = 0
      newItem.note = ''
      newItem.instruction = ''
      this.$emit('ItemFound', newItem)
    },
    cancel() {
      this.pickedItem = undefined
      this.searchItem = ''
    }

  }
}
</script>
